import { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "./AuthContext";
import { getUserHubs } from "../services/hubService";

const HubContext = createContext();

export const HubProvider = ({ children }) => {
  const { user } = useAuth();
  const [hub, setHub] = useState(null);
  const [hubs, setHubs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user?.id) {
      setLoading(false);
      return;
    }
    const fetch = async () => {
      try {
        const res = await getUserHubs(user.id);
        setHubs(res);
        if (res.length > 0) setHub(res[0]);
      } catch {
        // fail silently
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, [user]);

  return (
    <HubContext.Provider value={{ hub, hubs, setHub, loading }}>
      {children}
    </HubContext.Provider>
  );
};

export const useHub = () => useContext(HubContext);
